import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <div className={`text-2xl font-light tracking-wider transition-colors ${isScrolled ? 'text-emerald-600' : 'text-white'}`}>
                AURA BOTANICA
              </div>
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white hover:text-emerald-300'}`}>
                TOP
              </Link>
              <Link to="/about" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white hover:text-emerald-300'}`}>
                ABOUT
              </Link>
              <Link to="/products" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white hover:text-emerald-300'}`}>
                PRODUCTS
              </Link>
              <Link to="/news" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white hover:text-emerald-300'}`}>
                NEWS
              </Link>
              <Link to="/contact" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white hover:text-emerald-300'}`}>
                CONTACT
              </Link>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white md:hidden">
          <div className="flex flex-col items-center justify-center h-full space-y-8">
            <button 
              onClick={() => setIsMenuOpen(false)}
              className="absolute top-6 right-6 w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className="ri-close-line text-3xl text-gray-800"></i>
            </button>
            <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-xl font-medium text-gray-800 hover:text-emerald-600 transition-colors cursor-pointer">
              TOP
            </Link>
            <Link to="/about" onClick={() => setIsMenuOpen(false)} className="text-xl font-medium text-gray-800 hover:text-emerald-600 transition-colors cursor-pointer">
              ABOUT
            </Link>
            <Link to="/products" onClick={() => setIsMenuOpen(false)} className="text-xl font-medium text-gray-800 hover:text-emerald-600 transition-colors cursor-pointer">
              PRODUCTS
            </Link>
            <Link to="/news" onClick={() => setIsMenuOpen(false)} className="text-xl font-medium text-gray-800 hover:text-emerald-600 transition-colors cursor-pointer">
              NEWS
            </Link>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="text-xl font-medium text-gray-800 hover:text-emerald-600 transition-colors cursor-pointer">
              CONTACT
            </Link>
          </div>
        </div>
      )}
    </>
  );
}